import * as React from 'react';
import { CustomerAgreementListItem } from '../types';

export type CustomerAgreementDialogState =
    | { mode: 'closed' }
    | { mode: 'create' }
    | { mode: 'edit'; customerAgreement: CustomerAgreementListItem };

type UseCustomerAgreementDialog = {
    dialog: CustomerAgreementDialogState;
    openCreateDialog: () => void;
    openEditDialog: (customerAgreement: CustomerAgreementListItem) => void;
    closeDialog: () => void;
};

export function useCustomerAgreementDialog(): UseCustomerAgreementDialog {
    const [dialog, setDialog] = React.useState<CustomerAgreementDialogState>({ mode: 'closed' });

    return {
        dialog,
        openCreateDialog: () => setDialog({ mode: 'create' }),
        openEditDialog: (customerAgreement: CustomerAgreementListItem) =>
            setDialog({ mode: 'edit', customerAgreement }),
        closeDialog: () => setDialog({ mode: 'closed' })
    };
}
